var exports = {
  "MO": "VoiceParticipantItem.module__participantRow___M0V3T3",
  "Kq": "VoiceParticipantItem.module__participantRowSpeaking___M0V3T3",
  "JN": "VoiceParticipantItem.module__participantRowDragging___M0V3T3",
  "z": "VoiceParticipantItem.module__participantRowCurrentConnection___M0V3T3",
  "B$": "VoiceParticipantItem.module__participantRowPopoutOpen___M0V3T3",
  "K0": "VoiceParticipantItem.module__participantRowContextMenuActive___M0V3T3",
  "Kt": "VoiceParticipantItem.module__deviceIcon___M0V3T3",
  "iY": "VoiceParticipantItem.module__deviceIconSpeaking___M0V3T3",
  "ns": "VoiceParticipantItem.module__deviceIconCurrent___M0V3T3",
  "zc": "VoiceParticipantItem.module__iconContainer___M0V3T3",
  "F8": "VoiceParticipantItem.module__participantName___M0V3T3",
  "xr": "VoiceParticipantItem.module__participantNameSpeaking___M0V3T3",
  "S$": "VoiceParticipantItem.module__participantNameCurrent___M0V3T3",
  "_q": "VoiceParticipantItem.module__iconsContainer___M0V3T3",
  "nt": "VoiceParticipantItem.module__flexShrinkZero___M0V3T3",
};

module.exports = exports;
